

// turning ai2html's output into a module allows
// webpack to apply hot module replacement.
// we obviously want to bake it into the html in production
// that's why we're conditionally requiring it

import { Child } from 'pym.js';

import fetch from 'unfetch';

// import ai2html from './ai2html-graphic.html';
import meta from './data/meta.json';
import Zion from './utils/Zion';

// utils
import { stylePremium } from './utils/helpers';

// styles
import './styles/graphic.scss';

const jsonFeed = `https://ix.cnn.io/data/ukraine-refugees/archive/by-country/2022-03-14.json?t=${Date.now()}`;
let data;

// D3 stuff
const _ = {};
_.assign = require('lodash.assign');
const d3 = _.assign({},
  require('d3-array'),
  require('d3-format'),
  require('d3-selection'),
  require('d3-time-format'),
  require('d3-scale'));
const pkg = require('../package.json');


const fTime = d3.timeFormat('%B %-d, %Y');
const pTime = d3.timeParse('%Y-%m-%d');

d3.timeFormatDefaultLocale({
  periods: ['a.m.', 'p.m.'],
  shortDays: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
  days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
  months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
  shortMonths: ['Jan.', 'Feb.', 'March', 'April', 'May', 'June', 'July', 'Aug.', 'Sept.', 'Oct.', 'Nov.', 'Dec.'],
});

const formatComma = d3.format(',');
let artboard;
let maxRadius;
let labelLineHeight;
function roundNum(val) {
  const int = parseInt(val);
  if (int > 1000000) {
    return `${(int / 1000000).toFixed(1)} million`;
  }
  if (int > 1000) {
    return formatComma(Math.round(int / 1000) * 1000);
  }
  return 'Fewer than 1,000';
}
const regionHash = {
  'Republic of Moldova': 'Moldova',
  'Russian Federation': 'Russia',
};
function checkRegion(region) {
  return regionHash[region] != undefined ? regionHash[region] : region;
}

// For now import the json
// const data = require('./data/ref.json');


let ai2html = null;

if (process.env.NODE_ENV === 'development') {
  // turning ai2html's output into a module allows
  // webpack to apply hot module replacement.
  // we obviously want to bake it into the html in production
  // that's why we're conditionally requiring it
  ai2html = require('./ai2html-graphic.html');
}


console.clear();

window.onload = () => {
  // necessary evil for right now
  fetch(jsonFeed)
    .then(r => r.json())
    .then((d) => {
      data = d;
      // eslint-disable-next-line  no-use-before-define
      window.pymChild = new Child({ renderCallback: draw });
      window.addEventListener('resize', draw);

      if (process.env.NODE_ENV === 'development') {
        Object.keys(meta).forEach((id) => {
          const node = document.querySelector(`.${id}`);

          if (node) {
            node.innerHTML = meta[id];
          }
        });
      }

      const { pymChild } = window;
      pymChild.sendHeight();

      // If embedded, send Zion page view event
      if (window.pymChild.parentUrl) {
        const zion = new Zion(pkg.name, pymChild.parentUrl.split('?')[0]);
      }
      // Rejigger for svg drawing
      setTimeout(() => {
        drawBubbles();
        pymChild.sendHeight();
      }, 800);

      setTimeout(() => {
        d3.select('#area-bubbles').style('height', '100%');
        drawBubbles();
      }, 1000);
    });
};

const CNNPolitics = false;
const CNNBusiness = false;

stylePremium(CNNPolitics, CNNBusiness);

function draw() {
  // Get window size
  const windowW = window.innerWidth;
  artboard = windowW >= 780 ? '780' : windowW >= 700 ? '700' : windowW <= 320 ? '320' : '375';
  maxRadius = artboard === '780' ? 70 : artboard === '700' ? 50 : artboard === '320' ? 30 : 35;
  labelLineHeight = artboard === '780' || '700' ? 15 : artboard === '320' ? 10 : 12;

  if (process.env.NODE_ENV === 'development') {
    // the code below applies the ai2html
    // during development mode.

    const figure = document.querySelector('#ai2html-graphic');
    figure.innerHTML = ai2html;

    // If you want to write code for this graphic,
    // move this stuff outside the if block that it's in.
  }
  drawBubbles();
}

function drawBubbles() {
  // Get max refugees
  const refMax = d3.max(data.data.map(d => d.cnnIndividuals));

  // Set domain by screen size (adjust max radius)
  const scale = d3.scaleSqrt()
    .domain([0, refMax])
    // This should be dependent on screensize
    .range([0, maxRadius]);

  const pos780 = {
    // Poland
    Poland: ['16%', '33%', 'c'],
    // Hungary
    Hungary: ['11%', '73%', 'r'],
    // Other
    'Other European countries': ['-100%', '-100%', 'c'],
    // Moldova
    Moldova: ['50.8%', '70.5%', 'b'],
    // Slovakia
    Slovakia: ['13.5%', '59.5%', 'r'],
    // Romania
    Romania: ['36.75%', '78.75%', 'b'],
    // Russian Federation
    Russia: ['82%', '20%', 'b'],
    // Belarus
    Belarus: ['49.25%', '22.75%', 'b'],
  };

  const pos700 = {
    // Poland
    Poland: ['16%', '33%', 'c'],
    // Hungary
    Hungary: ['11%', '73%', 'r'],
    // Other
    'Other European countries': ['-100%', '-100%', 'c'],
    // Moldova
    Moldova: ['50.8%', '69.5%', 'b'],
    // Slovakia
    Slovakia: ['13.5%', '59.5%', 'r'],
    // Romania
    Romania: ['36.75%', '78.75%', 'b'],
    // Russian Federation
    Russia: ['82%', '20%', 'b'],
    // Belarus
    Belarus: ['49.25%', '22.75%', 'b'],
  };

  const pos375 = {
    // Poland
    Poland: ['13%', '40%', 'c'],
    // Hungary
    Hungary: ['9%', '76%', 'r'],
    // Other
    'Other European countries': ['-100%', '-100%', 'c'],
    // Moldova
    Moldova: ['49.5%', '70.75%', 'b'],
    // Slovakia
    Slovakia: ['10.5%', '63.5%', 'r'],
    // Romania
    Romania: ['35.75%', '78.75%', 'b'],
    // Russian Federation
    Russia: ['82.5%', '25%', 'b'],
    // Belarus
    Belarus: ['47.25%', '29%', 'b'],
  };

  const pos320 = {
    // Poland
    Poland: ['14%', '39%', 'c'],
    // Hungary
    Hungary: ['9%', '75%', 'r'],
    // Other
    'Other European countries': ['-100%', '-100%', 'c'],
    // Moldova
    Moldova: ['50.8%', '71.5%', 'b'],
    // Slovakia
    Slovakia: ['10%', '63%', 'r'],
    // Romania
    Romania: ['36.75%', '78.75%', 'b'],
    // Russian Federation
    Russia: ['82%', '25%', 'b'],
    // Belarus
    Belarus: ['49.25%', '29.75%', 'b'],
  };

  const pos = artboard === '780' ? pos780 : artboard === '700' ? pos700 : artboard === '320' ? pos320 : pos375;

  // Detect screen size for different positioning

  // Bind and draw bubbles for each data on the SVG
  const svg = d3.select('#area-bubbles');
  // Empty svg
  svg.selectAll('g').remove();
  svg.selectAll('defs').remove();

  // Add strip definition
  svg.append('defs').html('<pattern id="hash4_4" width="8" height="8" patternUnits="userSpaceOnUse" patternTransform="rotate(45)"> <rect width="5" height="800" transform="translate(0,0)" fill="rgba(248, 156, 60, .65)"></rect> </pattern>');

  // Draw groups for each bubble and label group
  const bubbs = svg.append('g')
    .attr('class', 'bubbles')
    .selectAll('g')
    .data(data.data)
    .enter()
    .append('g')
    .attr('id', d => d.cnnName)
    // Position bubble based on screen size
    .style('transform', (d, i) => `translate(${pos[d.cnnName][0]},${pos[d.cnnName][1]})`);

  // Draw the bubbles above
  const bubble = bubbs.append('circle')
    .attr('class', d => `bubble ${d.cnnName.toLowerCase().split(' ').join('-')}`)
    .attr('r', d => (d.cnnName === 'Russia' ? scale(`${d.cnnIndividuals + 96000}`) : scale(d.cnnIndividuals)));

  // Draw label groups for each country bubble
  const labelGroup = bubbs.append('g')
    .attr('class', 'label-group')
    .style('transform', (d, i) => {
      const spacing = (d.cnnName === 'Russia' ? scale(`${d.cnnIndividuals + 96000}`) : scale(d.cnnIndividuals));
      if (pos[d.cnnName][2] === 'c') {
        return null;
      }
      if (pos[d.cnnName][2] === 'r') {
        return `translate(${(spacing * 1.8) + 15}px, -10px)`;
      }
      if (pos[d.cnnName][2] === 'b') {
        return `translateY(${(spacing * 1.1) + 15}px)`;
      }
    });

  // Country label
  const countryLabel = labelGroup.append('text')
    .text(d => checkRegion(d.cnnName))
    .attr('class', 'country-label');

  // Number label
  const numberLabel = labelGroup.append('text')
    .text(d => roundNum(d.cnnIndividuals))
    .attr('dy', labelLineHeight)
    .attr('class', 'number-label');

  // Update Ukraine total
  // this is data.total
  const ukraineLabel = svg.append('g')
    .attr('class', 'label-group')
    .style('transform', () => {
      if (artboard === '780') {
        return 'translate(62.5%, 55.5%)';
      } if (artboard === '700') {
        return 'translate(62.5%, 54.5%)';
      } if (artboard === '375') {
        return 'translate(62.5%, 60%)';
      }
      return 'translate(62.5%, 59.5%)';
    });

  ukraineLabel.append('text')
    .attr('class', 'ukraine-label')
    .text(() => (artboard === '780' ? `At least ${roundNum(data.total)} refugees have left the country` : `At least ${roundNum(data.total)} refugees`));

  // Second line to label for mobile
  if (artboard !== '780') {
    ukraineLabel.append('text')
      .attr('class', 'ukraine-label')
      .attr('dy', labelLineHeight)
      .text('have left the country');
  }

  // Update the note with European country totals
  const euroIndividuals = data.data.filter(d => d.cnnName === 'Other European countries')[0].individuals;
  const noteText = `<strong>Not shown on this map: ${roundNum(euroIndividuals)} refugees who have left Ukraine for other European countries</strong><br>
  Moldova and Romania figures represent the total number of refugees currently in those countries. Data for all other countries represents the total number of arrivals since Feb. 24.`;
  d3.select('.footnote').html(noteText);

  // Update date in note
  const source = d3.select('.source');
  const sourceTxt = 'Source: United Nations High Commissioner for Refugees. ';
  source.text(`${sourceTxt}Data as of ${fTime(pTime(data.lastUpdated.split('T')[0]))}.`);
}
